import { simpleSet } from '@r/reducers/utils';

const setCalculationModePullsOptions = simpleSet as
  redux.reducers.calculationMode.projects.currentProject.settings.materials.pulls.options;

export const options = setCalculationModePullsOptions(
  'SET_CALCULATION_MODE_CURRENT_PROJECT_PULLS_OPTIONS',
  []
);
